export default __webpack_public_path__ + "static/media/Fullbanner.6350938a.jpg";